import { Card, Checkbox, Col, Form, Input, Radio, Row, Space, Typography } from "antd";
import React, { useEffect } from "react";
const { Title } = Typography;

const RecordRelease = ({ getChildData, bulkRequestData, form }) => {
  const onChange = (e) => {
    callparent(e.target.value, "RecordMethod");
  };
  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Please enter a valid phone number."));
  };
  const callparent = (value, name) => {
    getChildData(value, name);
  };

  useEffect(() => {
    if (bulkRequestData.useRequesterInformation)
      form.setFieldsValue({
        bnameorganization: bulkRequestData.RequesterName,
        bphone: bulkRequestData.RequesterPhoneNumber,
        bemail: bulkRequestData.RequesterEmail,
        // bfax: bulkRequestData.RequesterFaxNumber,
      });
    else
      form.setFieldsValue({
        bnameorganization: bulkRequestData.RecordName,
        bphone: bulkRequestData.RecordPhoneNumber,
        bemail: bulkRequestData.RecordEmail,
        bfax: bulkRequestData.RecordFaxNumber,
      });
  }, [bulkRequestData.useRequesterInformation]);


  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          Recipient Information
        </Title>
      }
    >
      <Row className="px-6" gutter={[20, 0]}>
        <Col span={24}>
          <Form.Item
            name="releasemethod"
            required
            className="font-medium"
            label="What method of release would you like?"
            rules={[{ required: true, message: "Please choose any option." }]}
          >
            <Radio.Group onChange={(e) => onChange(e)} value={bulkRequestData.RecordMethod}>
              <Space direction="vertical" className="ms-4"
              >
                <Radio value="email" className="font-normal">
                  Email
                </Radio>
                <Radio value="fax" className="font-normal">
                  Fax
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item></Col>

        {bulkRequestData.RecordMethod === "fax" ? (
          <>
            <Col xs={24} md={12}>
              <Form.Item
                className="font-medium"
                label="Recipient's Name/Organization"
                onChange={(e) => callparent(e.target.value, "RecordMethodReleaseName")}
                name="RecordMethodReleaseName"
                rules={[
                  { required: true, max: 50, message: "Please enter recipient name or organization." },
                ]}
              >
                <Input maxLength={50} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                className="font-medium"
                label="Recipient's Fax Number"
                name="rfaxnumber"
                onChange={(e) =>
                  callparent(e.target.value, "RecordMethodReleaseFaxNumber")
                }
                rules={[
                  { required: true, max: 20, message: "Please enter recipient fax number." },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </>
        ) : bulkRequestData.RecordMethod === "email" ? <>
          <Col xs={24} md={12}>
            <Form.Item
              className="font-medium"
              label="Recipient's Name/Organization"
              onChange={(e) => callparent(e.target.value, "RecordMethodReleaseName")}
              name="RecordMethodReleaseName"
              rules={[
                { required: true, max: 50, message: "Please enter recipient name or organization." },
              ]}
            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              className="font-medium"
              label="Recipient's Email"
              name="RecordMethodReleaseEmail"
              onChange={(e) => callparent(e.target.value, "RecordMethodReleaseEmail")}
              required
              rules={[
                { required: true, max: 100, message: "Please enter email." },
                { type: "email", message: "Please enter valid email." },
              ]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
        </> : null}

        <Col span={24}>
          <Form.Item
            label="If there is a fee, who is the best person for us to contact?"
            required
          >
            <Checkbox className="font-medium"
              valuePropName="checked"
              onChange={(e) =>
                callparent(e.target.checked, "useRequesterInformation")
              }
              checked={bulkRequestData.useRequesterInformation}>
              Use requester information
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[20, 0]} className="px-6">
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            required
            label="Name/Organization"
            onChange={(e) => callparent(e.target.value, "RecordName")}
            name="bnameorganization"
            rules={[
              { required: true, max: 50, message: "Please enter name or organization." },
            ]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="bphone"
            label="Phone Number"
            onChange={(e) => callparent(e.target.value, "RecordPhoneNumber")}
            required
            rules={[
              { required: true, max: 20, message: "Please enter phone number." },
              { validator: validatePhone },
            ]}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label="Email"
            name="bemail"
            onChange={(e) => callparent(e.target.value, "RecordEmail")}
            required
            rules={[
              { required: true, max: 100, message: "Please enter email." },
              { type: "email", message: "Please enter valid email." },
            ]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium" name="bfax" label="Fax Number" onChange={(e) => callparent(e.target.value, "RecordFaxNumber")}>
            <Input maxLength={20} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default RecordRelease;
